// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"JobActions_dropdown__l3MdF"};